import { DEFAULT_MAX_ATTEMPTS } from "../../../../shared/delivery/max-attempts";
import { type QueueState } from "./state";

export const initialState: QueueState = {
  queue: [],
  ambassadors: [],
  isPending: false,
  isRejected: false,
  errorMessage: "",
  isActing: false,
  actionError: "",
  maxAttempts: DEFAULT_MAX_ATTEMPTS,
};
